import { useEffect, useState } from 'react';
import { useForm } from 'commons/hooks';
import { useGetRecipient } from 'domains/PagoNubeOnboarding/Recipient/hooks';
import { mapRecipientToPersonalData } from 'domains/PagoNubeOnboarding/Recipient/utils';
import useOnboardingValidationSchema from './useOnboardingValidationSchema';
import { usePlaceOfResidence } from './usePlaceOfResidence';
import { PersonalDataState } from '../types';

const initialValues: PersonalDataState = {
  firstName: '',
  lastName: '',
  phoneNumberPrefix: '+52',
  phoneNumber: '',
  birthDate: '',
  storeCategory: '',
  state: '',
  city: '',
  locality: '',
  street: '',
  streetNumber: 0,
  zipCode: '',
};

export const useFormValidation = (onSubmit: any) => {
  const [initialPersonalData, setInitialPersonalData] =
    useState<PersonalDataState>(initialValues);

  const { recipientData } = useGetRecipient();
  const onboardingValidation = useOnboardingValidationSchema();

  useEffect(() => {
    if (recipientData?.id) {
      const personalData = mapRecipientToPersonalData(recipientData);
      setInitialPersonalData(personalData);
    }
  }, [recipientData]);

  const {
    values,
    errors,
    handleOnBlur,
    handleOnChange,
    handleOnSubmit,
    setMultipleFieldValues,
  } = useForm<PersonalDataState>({
    initialValues: initialPersonalData,
    onSubmit,
    validationSchema: onboardingValidation,
    validateOnBlur: [
      'firstName',
      'lastName',
      'phoneNumberPrefix',
      'phoneNumber',
      'birthDate',
      'storeCategory',
      'street',
      'streetNumber',
      'zipCode',
    ],
  });

  const {
    handleChangeAddressesData,
    handleChangeStreetNumber,
    isAddressesMexicoError,
    isAddressesMexicoLoading,
    isWithoutStreetNumberChecked,
  } = usePlaceOfResidence({
    initialValues,
    handleOnChange,
    setMultipleFieldValues,
  });

  return {
    errors,
    handleOnBlur,
    handleChangeAddressesData,
    handleChangeStreetNumber,
    handleOnChange,
    handleOnSubmit,
    isAddressesMexicoError,
    isAddressesMexicoLoading,
    isWithoutStreetNumberChecked,
    values,
  };
};
